// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-button {
    cursor: pointer;
    width: 1.25rem; /* w-5 */
    height: 1.25rem; /* h-5 */
    background: transparent;
    border: none;
    outline: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
}

.icon-button:hover {
    color: #2563eb; /* Tailwind's blue-600 */
}
`, "",{"version":3,"sources":["webpack://./src/components/CreateNewProject/AddEditGeoFenceForm.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc,EAAE,QAAQ;IACxB,eAAe,EAAE,QAAQ;IACzB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc,EAAE,wBAAwB;AAC5C","sourcesContent":[".icon-button {\n    cursor: pointer;\n    width: 1.25rem; /* w-5 */\n    height: 1.25rem; /* h-5 */\n    background: transparent;\n    border: none;\n    outline: none;\n    box-shadow: none;\n    padding: 0;\n    margin: 0;\n}\n\n.icon-button:hover {\n    color: #2563eb; /* Tailwind's blue-600 */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
